angular.module("folkeuni").directive("registerForm", function () {
  return {
    require: "form",
    scope: false,
    link: function (scope, elem, attrs, formCtrl) {
      var idx = attrs.name;
      if (scope.$parent && scope.$parent.registerForm) {
        scope.$parent.registerForm(idx, formCtrl);
      }
    },
  };
});
